import type { FiltersConfig } from '@openx/types/chipFilters';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { mapTaxonomyFilters } from '../../../utils/mapTaxonomyFilters';
import type { TaxonomyMetadata } from '../types';

export const useFiltersConfig = (metadata: TaxonomyMetadata[]) => {
  const { t } = useTranslation();

  const { categories, sources, subCategories, types } = useMemo(() => mapTaxonomyFilters(metadata), [metadata]);

  const filtersConfig: FiltersConfig = useMemo((): FiltersConfig => {
    return {
      segment_category: {
        multiple: true,
        name: t('Category'),
        options: categories.map(item => ({ displayName: item ?? undefined, value: item })) ?? [],
      },
      segment_source: {
        multiple: true,
        name: t('Source'),
        options: sources.map(item => ({ displayName: item ?? undefined, value: item })) ?? [],
      },
      segment_sub_category: {
        multiple: true,
        name: t('Sub Category'),
        options: subCategories.map(item => ({ displayName: item ?? undefined, value: item })) ?? [],
      },
      segment_type: {
        multiple: true,
        name: t('Type'),
        options: types.map(item => ({ displayName: item ?? undefined, value: item })) ?? [],
      },
    };
  }, [t, categories, subCategories, types, sources]);

  return filtersConfig;
};
